import { getRealVideoHeight, getRealVideoWidth } from '../../utils/playerProperties';
import { SSP_POSITIONS } from '../constants/positions';
import globalConsent from '../gdpr/globalConsent';

export default class AdUnit {
  constructor(config) {
    this.endpoint = config.endpoint; // 'js38770pc';
    this.code = `${parseInt(Math.random() * 10000, 10)}${Date.now()
      .toString()
      .substr(-4)}${parseInt(Math.random() * 10000000000, 10)}`;
    this.tappxKey = config.tappxKey;
    this.cvid = 0;
    this.cvurl = '';

    if (config.test || globalConsent.testDisplay) {
      this.test = 1;
    }
  }

  setDivId(divId) {
    this.divId = divId;
    return this;
  }

  setSizes(sizes, format = 'banner') {
    this.mediaTypes = {
      [format]: {
        sizes, // [[320, 250]], // array of sizes
      },
    };
    return this;
  }

  setTappxkey(tpxkey) {
    this.tappxKey.mweb = tpxkey.mweb;
    this.tappxKey.desktop = tpxkey.desktop;
    return this;
  }

  setTest(test) {
    this.test = test;
    return this;
  }

  setCvid(cvid) {
    this.cvid = cvid;
    return this;
  }

  setCvurl(cvurl) {
    this.cvurl = cvurl;
    return this;
  }

  setVideoParams(config, position) {
    this.vpos = SSP_POSITIONS.indexOf(position);
    this.vw = getRealVideoWidth(config);
    this.vh = getRealVideoHeight(config);
    return this;
  }

  build() {
    return {
      endpoint: this.endpoint,
      code: this.code,
      divId: this.divId,
      tappxKey: this.tappxKey,
      mediaTypes: this.mediaTypes,
      test: this.test,
      cvid: this.cvid,
      cvurl: this.cvurl,
    };
  }

  buildVideo() {
    return {
      ...this.build(),
      vpos: this.vpos,
      vh: this.vh,
      vw: this.vw,
    };
  }
}
